// js
import { flatten } from 'lodash';
import KeyGoals from '../analytics/pptx/KeyGoals';
import CriticalSecurityCorrelationsPPTX from '../analytics/pptx/CriticalSecurityCorrelationsPPTX';
import Overlap from '../analytics/Overlap';
import AdoptionOverviewPPTX from '../analytics/pptx/AdoptionOverviewPPTX';
import Adoption from '../analytics/Adoption';
import Overview from '../analytics/pptx/Overview';
import RollUpOverviewPPTX from '../analytics/pptx/RollUpOverviewPPTX';
import RollUpOverviewPPTXTwo from '../analytics/pptx/RollUpOverviewPPTXTwo';
import OverviewArea from '../analytics/pptx/OverviewArea';
import RecommendationsOne from '../../containers/analytics/pptx/RecommendationsOne';
import RecommendationsTwo from '../../containers/analytics/pptx/RecommendationsTwo';
import SecurityOverview from '../analytics/SecurityOverview';
import SecurityCriticalAcceptableDetailPPTX from '../../components/analytics/pptx/SecurityCriticalAcceptableDetailPPTX';
import SecurityCriticalRudimentaryDetailPPTX from '../../components/analytics/pptx/SecurityCriticalRudimentaryDetailPPTX';
import SecurityCriticalInadequateDetailPPTX from '../../components/analytics/pptx/SecurityCriticalInadequateDetailPPTX';
import SecurityNonCriticalAcceptableDetailPPTX from '../../components/analytics/pptx/SecurityNonCriticalAcceptableDetailPPTX';
import SecurityNonCriticalRudimentaryDetailPPTX from '../../components/analytics/pptx/SecurityNonCriticalRudimentaryDetailPPTX';
import SecurityNonCriticalInadequateDetailPPTX from '../../components/analytics/pptx/SecurityNonCriticalInadequateDetailPPTX';
import SecurityDashboardsOverview from '../analytics/SecurityDashboardsOverview';
import SecurityDashboardsDetail from '../../containers/analytics/SecurityDashboardsDetail';
import SecurityDashboardsOtherDetail from '../../containers/analytics/SecurityDashboardsOtherDetail';
import DataSourcesByArea from '../../containers/analytics/DataSourcesByArea';
import { pptxDataSourcesColors } from '../../constants/dataSourcesColors';

const singletonSlideDefinitions = [
  {
    Component: KeyGoals,
    name: 'pptx_key_goals'
  },
  {
    Component: CriticalSecurityCorrelationsPPTX,
    name: 'pptx_critical_security_correlations'
  },
  {
    Component: Overview,
    name: 'pptx_overview'
  },
  {
    Component: AdoptionOverviewPPTX,
    name: 'pptx_adoption_overview'
  },
  {
    Component: RollUpOverviewPPTX,
    name: 'pptx_roll_up_overview'
  },
  {
    Component: RollUpOverviewPPTXTwo,
    name: 'pptx_roll_up_overview_2'
  },
  {
    Component: RecommendationsOne,
    name: 'pptx_recommend_one'
  },
  {
    Component: RecommendationsTwo,
    name: 'pptx_recommend_two'
  },
  {
    Component: SecurityOverview,
    name: 'pptx_security_overview'
  },
  {
    Component: SecurityCriticalAcceptableDetailPPTX,
    name: 'pptx_security_critical_acceptable_detail'
  },
  {
    Component: SecurityCriticalRudimentaryDetailPPTX,
    name: 'pptx_security_critical_rudimentary_detail'
  },
  {
    Component: SecurityCriticalInadequateDetailPPTX,
    name: 'pptx_security_critical_inadequate_detail'
  },
  {
    Component: SecurityNonCriticalAcceptableDetailPPTX,
    name: 'pptx_security_non_critical_acceptable_detail'
  },
  {
    Component: SecurityNonCriticalRudimentaryDetailPPTX,
    name: 'pptx_security_non_critical_rudimentary_detail'
  },
  {
    Component: SecurityNonCriticalInadequateDetailPPTX,
    name: 'pptx_security_non_critical_inadequate_detail'
  },
  {
    Component: SecurityDashboardsOverview,
    name: 'pptx_security_dashboards_overview'
  },
  {
    Component: SecurityDashboardsOtherDetail,
    name: 'pptx_security_dashboards_other_detail'
  },
  {
    Component: DataSourcesByArea,
    name: 'pptx_data_sources_by_area',
    props: {
      colors: pptxDataSourcesColors,
      chartLabelFontSize: 54
    }
  }
];

const buildPerAreaSlideDefinitions = areas => (
  flatten(
    areas.map(area => [
      {
        Component: Overlap,
        name: `pptx_overlap_${area.id}`,
        areaId: area.id
      },
      {
        Component: Adoption,
        name: `pptx_adoption_${area.id}`,
        areaId: area.id
      },
      {
        Component: OverviewArea,
        name: `pptx_overview_${area.id}`,
        areaId: area.id
      }
    ])
  )
);

const buildPerDashboardCategorySlideDefinitions = dashboardCategories => (
  dashboardCategories.map(dashboardCategory => (
    {
      Component: SecurityDashboardsDetail,
      name: `pptx_security_dashboards_detail_${dashboardCategory.id}`,
      dashboardCategoryId: dashboardCategory.id
    }
  ))
);

const defaultSlideDefinition = {
  markup: '',
  areaId: null
};

const buildPPTXSlideDefinitions = ({ areas, dashboardCategories }) => (
  flatten([
    singletonSlideDefinitions,
    buildPerAreaSlideDefinitions(areas),
    buildPerDashboardCategorySlideDefinitions(dashboardCategories)
  ]).map(definition => Object.assign({}, defaultSlideDefinition, definition))
);

export default buildPPTXSlideDefinitions;



// WEBPACK FOOTER //
// ./src/containers/pptx/buildPPTXSlideDefinitions.js